export default "__VITE_ASSET__ATt5TGt4__"